const environment = process.env.NODE_ENV;
const project = "bulk ordering container";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  routes: {
    label: "Company",
    prefix: "/company"
  }
}

export default config;
